import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getResponse } from "../../Utils/Helper";
import CleverTapSdk from "../../Utils/CleverTapSdk";
import NoresultImage from "../NoresultImage";
import Results from "../Results";
import { uploadViaPresignedUrl } from "../../Utils/Helper";
import { WebcamCapture } from "../../common/Webcam";
import Loader from "../../common/Loader";
import $ from 'jquery';

export default function UploadImage(props) {
  const [results, setResults] = useState([]);
  const [isResult, setIsResult] = useState(false);
  const [preview, setPreview] = useState("");
  const [imagename, setImagename] = useState("");
  const [norecord, setNorecord] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();

  const handleUpload = async (myFile, imageurl) => {
    $('#preloader_bg').show();
    try {
      const key = await uploadViaPresignedUrl(myFile);
      setPreview(imageurl);
      setIsOpen(false);
      setImagename(key); // key is what searchImage() sends to find-faces
      $('#preloader_bg').hide();
    } catch (err) {
      $('#preloader_bg').hide();
      console.error("Upload failed:", err);
      // Temporary diagnostic — surface the real reason on screen.
      alert("Upload failed: " + (err && err.message ? err.message : "unknown") + ". Please try again.");
    }
  };

  const searchImage = () => {
    try {
      let obj = {};
      window.gtag("event", `Scan Photo`, obj);
    } catch (error) {}
    //face Recoginize api
    let data = {
      secretkey: "mnopqrstuvwxyz0123456789",
      accessToken: "XgaGEsmoZmLDtfbeqW+Ldw==",
      file: imagename,
    };

    try {
      $('#preloader_bg').show();
      getResponse(data).done((res) => {
        $('#preloader_bg').hide();
        if (
          res.resultFlag == 1 &&
          res.response &&
          res.response.FaceMatches &&
          res.response.FaceMatches.length > 0
        ) {
          try {
            let ctdata = {};
            ctdata["PhotoBooth_action"] = "search_successfully";
            CleverTapSdk.handleEventtracking(ctdata);
          } catch (error) {}

          localStorage.setItem(
            "listResult",
            JSON.stringify(res.response.FaceMatches)
          );
          localStorage.setItem("backurl", "/scan-youface");
          setIsResult(true);
          setResults(res.response.FaceMatches);
          navigate("/list" + window.location.search);
        } else {
          try {
            let obj = {};
            window.gtag("event", ` Photo Unavailable`, obj);
          } catch (error) {}

          let ctdata = {};
          ctdata["PhotoBooth_action"] = "search_unsuccessfully";
          CleverTapSdk.handleEventtracking(ctdata);
          setNorecord(true);
          localStorage.setItem("listResult", []);
          localStorage.setItem("backurl", "/scan-youface");
          setIsResult(false);
          setResults([]);
        }
      }).fail((jqXHR, textStatus) => {
        // Face-match API failed — hide the loader instead of spinning forever.
        $('#preloader_bg').hide();
        console.error("searchImage failed:", jqXHR && jqXHR.status, textStatus);
        alert("Something went wrong. Please try again.");
      });
    } catch (error) {
      $('#preloader_bg').hide();
      console.error("searchImage failed", error);
    }
  };

  const handleNoRecords = () => {
    setNorecord(false);
    setIsResult(false);
  };

  const openCamera = (arg = true) => {
    setIsOpen(arg);
  };

  // `?type=file` switches the scan screen from live camera to a file/photo
  // picker. The rest of the flow (upload -> Next -> face match) is identical.
  // Navigations carry window.location.search, so the param is present on mount.
  const isFileMode =
    new URLSearchParams(window.location.search).get("type") === "file";

  const onFileSelect = (e) => {
    const file = e.target && e.target.files && e.target.files[0];
    if (file) {
      handleUpload(file, URL.createObjectURL(file));
    }
    // allow re-selecting the same file later
    e.target.value = "";
  };

  return (
    <>
      <Loader />
      {!isResult && !norecord ? (
        <>
          <div className="container-fluid">
            <div className="upload_imege_div">
              <div className="uploadimage_div uploadimage_div_custom">
                {isOpen ? (
                  isFileMode ? (
                    <label
                      className="scan_file_upload"
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        type="file"
                        accept="image/*"
                        onChange={onFileSelect}
                        style={{ display: "none" }}
                      />
                      <img src="/assets/images/folder.svg" alt="" />
                    </label>
                  ) : (
                    <WebcamCapture
                      openCamera={openCamera}
                      handleUpload={handleUpload}
                    />
                  )
                ) : (
                  <img
                    onClick={() => openCamera()}
                    src={preview ? preview : `/assets/images/scanner.svg`}
                    alt=""
                  />
                )}
              </div>
              <h5>{isFileMode ? "Upload your photo" : "Scan your face"}</h5>
              <p>
                {isFileMode
                  ? "Upload a clear, front-facing photo from your device."
                  : "Scan your face from front using your device’s camera."}
              </p>
              {preview && (
                <>
                  <div className="progress custom_progress">
                    <div
                      className="progress-bar custom_progress-bar"
                      style={{ width: "100%" }}
                    ></div>
                  </div>
                  <div className="image_detail">
                    <ul>
                      <li>
                        <p className="image_name">{imagename}</p>
                      </li>
                      <li>
                        <p
                          className="image_status"
                          onClick={() => searchImage()}
                        >
                          <img src="/assets/images/file.svg" alt="" /> Next
                        </p>
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : norecord ? (
        <NoresultImage handleNoRecords={handleNoRecords} />
      ) : (
        <Results preview={preview} filename={imagename} results={results} />
      )}
    </>
  );
}
